import { Slot, Slottable } from '@radix-ui/react-slot'
import { cva, VariantProps } from 'class-variance-authority'
import clsx from 'clsx'
import React, { ButtonHTMLAttributes } from 'react'

import Styles from './CircularButton.module.scss'

const circularButtonVariants = cva(Styles.circularButtonBase, {
  variants: {
    variant: {
      flat: Styles.flat,
      floating: Styles.floating
    },
    size: {
      normal: Styles.normal,
      small: Styles.small,
      tiny: Styles.tiny
    }
  },

  defaultVariants: {}
})

interface ICircularButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof circularButtonVariants> {
  asChild?: boolean
}

const CircularButton = React.forwardRef<
  HTMLButtonElement,
  ICircularButtonProps
>(({ className, variant, size, asChild = false, children, ...props }, ref) => {
  const Component = asChild ? Slot : 'button'

  return (
    <Component
      className={clsx(circularButtonVariants({ variant, size, className }))}
      data-testid="circular-button"
      ref={ref}
      {...props}>
      <Slottable>{children}</Slottable>
    </Component>
  )
})
CircularButton.displayName = 'CircularButton'

export type { ICircularButtonProps }
export default CircularButton
